import React, { ReactNode } from "react";
import LocaleSwitcher from "./locale-switcher";
import useTranslator from "@pma/hooks/use-translator";
import { cn } from "@pma/utils/helpers";

interface Props {
  children: ReactNode;
}
const ROGBackground = ({ children }: Props) => {
  const { locale } = useTranslator();
  const isHebrew = locale === "he";
  return (
    <div className="relative h-[100vh] overflow-hidden bg-[#1e1e1e]">
      <div className="triangle"></div>
      <div className="rectangle"></div>
      <div
        className={cn(
          "absolute z-40 top-4 flex h-fit w-fit flex-col items-center justify-center",
          isHebrew ? "left-4" : "right-4",
        )}
      >
        <LocaleSwitcher />
      </div>

      <div
        id="rog-bg-container-wrap"
        className="absolute bottom-0 left-0 right-0 top-0 flex h-full w-full flex-col items-center justify-center"
      >
        {children}
      </div>
    </div>
  );
};

export default ROGBackground;
